/* ============================================================
   LiquorVerse "Your Verse" dashboard behavior (account-page-v3).
   - Wishlist panel: renders LVWishlist handles (§7 single
     write-point) via /products/{handle}.js
   - Restock alerts: localStorage list — KLAVIYO SEAM: swaps to
     Klaviyo back-in-stock subscriptions with the apps pass (§7)
   - Brand bells + comms toggles: localStorage now — KLAVIYO
     SEAM: writes become Klaviyo profile properties (§4) via the
     integrations pass; UI contract stays identical
   - One-tap reorder: LVCart.addMany from data-payload
   ============================================================ */
(function () {
  'use strict';

  var RESTOCK_KEY = 'lv_restock';
  var BELLS_KEY = 'lv_brand_bells';
  var COMMS_KEY = 'lv_comms';

  function readStore(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key));
      return v && typeof v === 'object' ? v : Array.isArray(v) ? v : {};
    } catch (e) { return {}; }
  }
  function readList(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  function money(cents) {
    return window.LV ? window.LV.fmtUSD(cents) : '$' + Math.round(cents / 100);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js').then(function (r) {
      if (!r.ok) throw new Error('gone');
      return r.json();
    });
  }

  /* ---------------- Wishlist panel ---------------- */
  function renderWishlist() {
    var panel = document.querySelector('[data-lv-acct-wishlist]');
    if (!panel || !window.LVWishlist) return;
    var handles = window.LVWishlist.all();
    var body = panel.querySelector('[data-lv-rows]');
    var empty = panel.querySelector('[data-lv-empty]');
    if (!body) return;
    body.innerHTML = '';
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    handles.forEach(function (handle) {
      fetchProduct(handle).then(function (p) {
        var row = document.createElement('div');
        row.className = 'lv-alert-row';
        var variant = p.variants && p.variants[0];
        row.innerHTML =
          '<div><b><a href="/products/' + p.handle + '">' + p.title + '</a></b>' +
          '<div><span class="lv-alert-st ' + (p.available ? 'back' : 'watch') + '">' + (p.available ? '● In stock — ' + money(p.price) : '◐ Out of stock') + '</span></div>' +
          '<button type="button" class="lv-alert-rm" data-lv-wl-remove="' + p.handle + '">Remove</button></div>' +
          (p.available && variant ? '<button type="button" class="lv-mini-add" data-lv-add-id="' + variant.id + '">Add to cart</button>' : '');
        body.appendChild(row);
      }).catch(function () {
        window.LVWishlist.remove(handle); /* product deleted — self-heal */
      });
    });
  }

  /* ---------------- Restock alerts ---------------- */
  function renderRestock() {
    var panel = document.querySelector('[data-lv-acct-restock]');
    if (!panel) return;
    var list = readList(RESTOCK_KEY);
    var body = panel.querySelector('[data-lv-rows]');
    var empty = panel.querySelector('[data-lv-empty]');
    var counter = document.querySelector('[data-lv-restock-count]');
    if (counter) counter.textContent = list.length;
    if (!body) return;
    body.innerHTML = '';
    if (!list.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    list.forEach(function (handle) {
      fetchProduct(handle).then(function (p) {
        var row = document.createElement('div');
        row.className = 'lv-alert-row';
        var variant = p.variants && p.variants[0];
        row.innerHTML = p.available
          ? '<div><b><a href="/products/' + p.handle + '">' + p.title + '</a></b>' +
            '<div><span class="lv-alert-st back">● Back in stock — ' + money(p.price) + '</span></div>' +
            '<button type="button" class="lv-alert-rm" data-lv-rs-remove="' + p.handle + '">Remove</button></div>' +
            (variant ? '<button type="button" class="lv-mini-add" data-lv-add-id="' + variant.id + '">Add to cart</button>' : '')
          : '<div><b><a href="/products/' + p.handle + '">' + p.title + '</a></b>' +
            '<div><span class="lv-alert-st watch">◐ Watching — we\'ll flag it here</span></div>' +
            '<button type="button" class="lv-alert-rm" data-lv-rs-remove="' + p.handle + '">Remove</button></div>';
        body.appendChild(row);
      }).catch(function () {
        var next = readList(RESTOCK_KEY).filter(function (h) { return h !== handle; });
        write(RESTOCK_KEY, next);
      });
    });
  }

  /* ---------------- Brand bells + comms toggles ---------------- */
  function initBells() {
    var bells = readStore(BELLS_KEY);
    document.querySelectorAll('[data-lv-bell]').forEach(function (chip) {
      var brand = chip.dataset.lvBell;
      function paint(on) {
        chip.classList.toggle('on', on);
        var bell = chip.querySelector('[data-lv-bell-icon]');
        if (bell) bell.textContent = on ? '🔔' : '🔕';
      }
      paint(bells[brand] !== false); /* default: following ordered brands */
      chip.addEventListener('click', function () {
        var current = readStore(BELLS_KEY);
        var next = !(current[brand] !== false);
        current[brand] = next;
        write(BELLS_KEY, current);
        paint(next);
        /* KLAVIYO SEAM: push {brand_bell_<brand>: next} as a
           profile property once the integration ships (§4). */
      });
    });
  }
  function initComms() {
    var comms = readStore(COMMS_KEY);
    document.querySelectorAll('[data-lv-comms]').forEach(function (input) {
      var key = input.dataset.lvComms;
      if (key in comms) input.checked = !!comms[key];
      input.addEventListener('change', function () {
        var current = readStore(COMMS_KEY);
        current[key] = input.checked;
        write(COMMS_KEY, current);
        /* KLAVIYO SEAM: profile property write (§4). */
      });
    });
  }

  /* ---------------- One-tap reorder ---------------- */
  function initReorder() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lv-reorder]');
      if (!btn || btn.classList.contains('done')) return;
      var items;
      try { items = JSON.parse(btn.dataset.lvReorder); } catch (err) { return; }
      if (!window.LVCart || !items.length) return;
      btn.disabled = true;
      window.LVCart.addMany(items).then(function (res) {
        btn.disabled = false;
        /* hardened addMany resolves {ok:false,…} instead of lying — don't
           flip to ✓ on a failed add (sold-out line, offline, busy cart) */
        if (res && res.ok === false) {
          btn.textContent = res.reason === 'busy' ? 'Cart busy — try again' : 'Couldn’t add — try again';
          return;
        }
        btn.classList.add('done');
        btn.textContent = 'In your cart ✓';
      });
    });
    document.addEventListener('click', function (e) {
      var wl = e.target.closest('[data-lv-wl-remove]');
      if (wl && window.LVWishlist) {
        window.LVWishlist.remove(wl.dataset.lvWlRemove);
        renderWishlist();
      }
      var rs = e.target.closest('[data-lv-rs-remove]');
      if (rs) {
        write(RESTOCK_KEY, readList(RESTOCK_KEY).filter(function (h) { return h !== rs.dataset.lvRsRemove; }));
        renderRestock();
      }
    });
  }

  function boot() {
    renderWishlist();
    renderRestock();
    initBells();
    initComms();
    initReorder();
    document.addEventListener('lv:wishlist:change', renderWishlist);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
